import React, { useEffect} from 'react';
import AppointmentHistorySection from '../../PageComponent/ProfilePage/AppointmentHistorySection';
function MobileAppoinmentHistory() {
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
 
  return (
  <AppointmentHistorySection />
  );
}

export default MobileAppoinmentHistory;
